import moment from 'moment-timezone';

export default function (date) {
  const myDate = new Date(date);
  const timezone = 'America/New_York';
  const format = 'h:mm a, MMM D, YYYY';
  const formattedDate = (moment(myDate).tz(timezone).format(format));

  const cleanDate = formattedDate.replace('Jan', 'Jan.')
    .replace('Feb', 'Feb.')
    .replace('Mar', 'March')
    .replace('Apr', 'April')
    .replace('Jun', 'June')
    .replace('Jul', 'July')
    .replace('Aug', 'Aug.')
    .replace('Sep', 'Sept.')
    .replace('Oct', 'Oct.')
    .replace('Nov', 'Nov.')
    .replace('Dec', 'Dec.')
    .replace('am', 'a.m.')
    .replace('pm', 'p.m.');

  if (cleanDate === 'Invalid date') {
    return '';
  }

  return cleanDate;
}
